import React, { useRef } from 'react';
var VeltData = function (props) {
    var path = props.path, field = props.field;
    var ref = useRef();
    return (React.createElement("velt-data", { ref: ref, path: path, field: field }));
};
export default VeltData;
